import React from 'react';
import PropTypes from 'prop-types';
import BaseDimensionDrilldownPopover from './BaseDimensionDrilldownPopover';
import { buildDrilldownRedirectQuery } from '../../utils/reports';
import { trackMixpanelEvent, REPORTS_EVENT_PREFIX } from '../../utils/general';

function DimensionDrilldownPopover({
    nodeData = null,
    selectedFilters = [],
    currentPath = null,
    dimensionList = [],
    availableFilters = [],
    reportSelectedFields = null,
    anchorEl = null,
    showPopover = true,
    closePopover = () => {},
    translate = () => {},
}) {
    const handleDimensionSelection = (dimensionField, nodeData) => {
        const redirectQuery = buildDrilldownRedirectQuery(
            reportSelectedFields.dimensions,
            availableFilters,
            selectedFilters,
            nodeData,
            dimensionField
        );

        const redirectPath = dimensionField.path ? dimensionField.path : currentPath.pathname;
        const redirectHref = window.location.href.replace(currentPath.pathname, redirectPath);
        const redirectUrl = `${redirectHref.substring(0, redirectHref.indexOf('?query'))}?${redirectQuery}`;

        trackMixpanelEvent(REPORTS_EVENT_PREFIX, 'Drilldown dimension clicked', {
            report_selected_fields: reportSelectedFields,
            report_selected_filters: selectedFilters,
            drilldown_dimension: dimensionField.display_name,
        });

        window.open(redirectUrl, '_blank');
    };

    return (
        <BaseDimensionDrilldownPopover
            dimensionList={dimensionList}
            nodeData={nodeData}
            anchorEl={anchorEl}
            showPopover={showPopover}
            closePopover={closePopover}
            onDimensionSelection={handleDimensionSelection}
            translate={translate}
        />
    );
}

DimensionDrilldownPopover.propTypes = {
    nodeData: PropTypes.any,
    selectedFilters: PropTypes.arrayOf(PropTypes.any),
    currentPath: PropTypes.any,
    dimensionList: PropTypes.arrayOf(PropTypes.any),
    availableFilters: PropTypes.arrayOf(PropTypes.any),
    reportSelectedFields: PropTypes.any,
    showPopover: PropTypes.bool,
    anchorEl: PropTypes.instanceOf(Element),
    closePopover: PropTypes.func,
    translate: PropTypes.func,
};

export default DimensionDrilldownPopover;
